import { useRuntimeConfig } from "#imports";
import { CLIENT_CONTEXT_PREFIX } from "../settings/index.js";
export function getEndpoint(operation, operationName) {
  const config = useRuntimeConfig();
  return `${config?.public?.["nuxt-graphql-middleware"]?.serverApiPrefix}/${operation}/${operationName}`;
}
export function encodeContext(context) {
  return Object.entries(context).reduce(
    (acc, [key, value]) => {
      if (typeof value === "string") {
        acc[CLIENT_CONTEXT_PREFIX + key] = value;
      }
      return acc;
    },
    {}
  );
}
